// removed by extract-text-webpack-plugin
module.exports = {"console":"Console__console","console-background-image":"Console__console-background-image","consoleBackgroundImage":"Console__console-background-image","console-image":"Console__console-image","consoleImage":"Console__console-image"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Console/Console.css
// module id = 1357
// module chunks = 8